<template>
    <div class="page-card">
        <el-card>
            <el-row :gutter="20">
                <el-col :sm="12" :md="14" :lg="16" :xl="16" class="m-b-10 m-b-md-0">
                    <el-date-picker
                            @change="changeDate"
                            value-format="yyyy-MM-dd HH:mm"
                            format="dd/MM/yyyy HH:mm"
                            class="w-100"
                            v-model="form.Date"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="От"
                            end-placeholder="До"
                            :clearable="false"
                            :picker-options="{ firstDayOfWeek: 1 }"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :sm="12" :md="10" :lg="8" :xl="8" class="d-flex">
                    <el-button :icon="$mobile() ? 'icon-clock' : ''" class="w-50" type="default" @click="handleToday">
                        Сегодня
                    </el-button>
                    <el-button :icon="$mobile() ? 'icon-search' : ''" class="w-50" type="primary" @click="handleFilter">
                        {{ ($mobile() ? 'Обновить данные' : 'Обновить') }}
                    </el-button>
                </el-col>
            </el-row>
        </el-card>

        <report name="AbonementsProlongating" :form="form" :key="formKey" :autoFetch="autoFetch" />
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                autoFetch: true,
                form: {
                    Date: [
                        (sessionStorage.getItem('dateFrom') ? sessionStorage.getItem('dateFrom') : Vue.moment().format('YYYY-MM-DD 00:00')),
                        (sessionStorage.getItem('dateTo') ? sessionStorage.getItem('dateTo') : Vue.moment().add(1, 'day').format('YYYY-MM-DD 00:00'))
                    ]
                },
                formKey: 0
            }
        },
        methods: {
            changeDate (date) {
                if (!date) {
                    this.form.Date = this.$today
                    sessionStorage.setItem('dateFrom', this.$today[0])
                    sessionStorage.setItem('dateTo', this.$today[1])
                }
                else {
                    sessionStorage.setItem('dateFrom', date[0])
                    sessionStorage.setItem('dateTo', date[1])
                }
                this.render()
            },
            handleFilter () {
                this.render()
            },
            handleToday () {
                this.form.Date = this.$today
                this.render()
            },
            render () {
                this.formKey += 1
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
